class Authenticator {
  static STORAGE_TOKEN = 'accessToken';

  /**
   * @param {ApiClient}     api
   * @param {GraphQLClient} graphql
   */
  constructor(api, graphql) {
    this.api = api;
    this.graphql = graphql;
  }

  /**
   * Create and store the access token
   *
   * @param {String} token
   */
  createToken(token) {
    localStorage.setItem(Authenticator.STORAGE_TOKEN, token);

    this.api.setToken(token);
    this.graphql.setToken(token);
  }

  /**
   * Get access token
   *
   * @return {String}
   */
  getToken() {
    const token = localStorage.getItem(Authenticator.STORAGE_TOKEN);

    this.api.setToken(token);
    this.graphql.setToken(token);

    return token;
  }

  /**
   * Remove stored access token
   */
  removeToken() {
    localStorage.removeItem(Authenticator.STORAGE_TOKEN);

    this.api.setToken(null);
    this.graphql.setToken(null);
  }

  /**
   * Is user authenticated?
   *
   * @return {Boolean}
   */
  isAuthenticated() {
    return !!this.getToken();
  }
}

export default Authenticator;



// WEBPACK FOOTER //
// ./src/api/Authenticator.js